import { Component, inject, output } from '@angular/core';
import { Router } from '@angular/router';
import { RiberaDefaultBtn } from '@ribera-web/ribera-default-btn';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-menu-mobile-partner',
  imports: [RiberaDefaultBtn, RouterLink],
  templateUrl: './menu-mobile-partner.html',
  styleUrl: './menu-mobile-partner.scss',
})
export class MenuMobilePartner {

  menuVisible = false;
  bookingsSubmenuOpen = false;
  emitCloseMenu = output<void>();

  private readonly DEFAULT_TOKEN =
  'eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJZQTQwNjYxMjY4Iiwicm9sZXMiOlt7ImF1dGhvcml0eSI6IjEifV0sImlkIjo3NTcsInN0YXRlIjoiQUNUSVZFIiwiaWF0IjoxNzYyMjkyOTU0LCJleHAiOjE3NjIyOTY1NTR9.LaBt-Ay5UQW1MBJhme0igZ9GKDLsMf-83eQN_enpsKCCig0QAOalftCRpwgrDqaB';


  closeMenu() {
    this.emitCloseMenu.emit();
  }

  toggleBookingSubmenu(event: Event) {
    event.stopPropagation();
    this.bookingsSubmenuOpen = !this.bookingsSubmenuOpen;
  }

  get isLoggedIn(): boolean {
    // Verifica si hay un token válido (no el token por defecto)
    const token = localStorage.getItem('accessToken');
    return !!token && token !== this.DEFAULT_TOKEN;
  }

  private router = inject(Router)

  logoOut() {
    localStorage.removeItem('accessToken');
    this.router.navigate(['/auth/login']);
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
